import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  // Three states: null = checking, true = authenticated, false = not authenticated
  const [isAuthenticated, setIsAuthenticated] = useState(
    location.state?.user ? true : null
  );

  useEffect(() => {
    // If we already have user from AuthCallback, skip check
    if (location.state?.user) {
      return;
    }

    const checkAuth = async () => {
      try {
        // Add delay only if NOT just authenticated
        const justAuth = sessionStorage.getItem('just_authenticated');
        if (!justAuth) {
          await new Promise(r => setTimeout(r, 150));
        } else {
          sessionStorage.removeItem('just_authenticated');
        }

        const response = await axios.get(`${API}/auth/me`, {
          withCredentials: true
        });

        if (response.data) {
          setIsAuthenticated(true);
        } else {
          setIsAuthenticated(false);
        }
      } catch (error) {
        console.error('Auth check failed:', error);
        setIsAuthenticated(false);
      }
    };

    checkAuth();
  }, []); // Empty deps - only run once

  // Still checking
  if (isAuthenticated === null) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #e0f2f7 0%, #fce4ec 100%)'
      }}>
        <div className="loading-spinner"></div>
      </div>
    );
  }

  // Not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Authenticated
  return children;
};

export default ProtectedRoute;
